import { SideDrawer } from '../../ui/SideDrawer/SideDrawer';
import { useState } from 'react';
import {
  QuestionMarkCircle,
  ExternalLinkIcon,
  LightBulbSupportIcon
} from '../../../icons/SvgIcons';
import { useDispatch } from 'react-redux';
import { startTutorialGuideFlow } from '../../../utils/Functions.utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../hooks/redux';
import { selectIsSuperAdmin } from '../../../store/selectors/authSelectors';

interface externalLink {
  title: string;
  url: string;
  icon: React.ReactNode;
  openInNewTab?: boolean;
}

const externalLinks: externalLink[] = [
  {
    title: 'The EU AI Act',
    url: 'https://eur-lex.europa.eu/eli/reg/2024/1689',
    icon: <ExternalLinkIcon />,
    openInNewTab: true
  },
  //   {
  //     title: 'How-to Videos',
  //     url: '#',
  //     icon: <ExternalLinkIcon />,
  //     openInNewTab: true,
  //   },
  //   {
  //     title: 'Give Us Feedback',
  //     url: '#',
  //     icon: <ExternalLinkIcon />,
  //     openInNewTab: true,
  //   },
  {
    title: 'Submit a Ticket',
    url: 'https://support.eucompliai.com/support/tickets/new',
    icon: <ExternalLinkIcon />,
    openInNewTab: true
  },
  {
    title: 'Knowledge Base',
    url: 'https://support.eucompliai.com/support/solutions',
    icon: <ExternalLinkIcon />,
    openInNewTab: true
  },
  {
    title: 'Privacy Policy',
    url: '/terms-and-privacy?tab=policy',
    icon: <ExternalLinkIcon />,
    openInNewTab: true
  },
  {
    title: 'Terms of Service',
    url: '/terms-and-privacy?tab=terms',
    icon: <ExternalLinkIcon />,
    openInNewTab: true
  }
];

export function Support() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isSuperAdminRole = useAppSelector(selectIsSuperAdmin);
  const [openSideDrawer, setOpenSideDrawer] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const onPlatformTourClick = async () => {
    try {
      await startTutorialGuideFlow(
        dispatch,
        'HELP',
        navigate,
        location.pathname
      );
      setOpenSideDrawer(false);
    } catch (error) {
      console.log('Error starting onboarding guide:', error);
    }
  };

  const makeExternalLink = (item: externalLink) => {
    return (
      <a
        key={item.title}
        href={item.url}
        {...(item.openInNewTab && {
          target: '_blank',
          rel: 'noopener noreferrer'
        })}
        className="flex items-center gap-3 px-4 py-2 hover:bg-gray-40 rounded-lg transition-colors duration-200 text-gray-800 hover:text-gray-900 flex-1"
      >
        {item.icon}
        <span className="font-normal text-sm leading-5">{item.title}</span>
      </a>
    );
  };

  const visibleExternalLinks = isSuperAdminRole
    ? externalLinks.filter((item) => item.title === 'Submit a Ticket')
    : externalLinks;

  // Group external links into pairs
  const groupedLinks: externalLink[][] = [];
  for (let i = 0; i < visibleExternalLinks.length; i += 3) {
    groupedLinks.push(visibleExternalLinks.slice(i, i + 3));
  }

  const listItems = [
    ...(!isSuperAdminRole
      ? [
          <div key="platform-tour" className="flex flex-col w-full">
            <button
              key="platform-tour"
              onClick={onPlatformTourClick}
              className="flex items-center gap-3 px-4 py-2 hover:bg-gray-40 rounded-lg transition-colors duration-200 text-gray-800 hover:text-gray-900 flex-1 font-normal text-sm leading-5"
            >
              <LightBulbSupportIcon />
              Platform Tour
            </button>
          </div>
        ]
      : []),
    ...groupedLinks.map((pair, index) => (
      <div key={index} className="flex flex-col w-full">
        {pair.map((item) => makeExternalLink(item))}
      </div>
    ))
  ];

  return (
    <>
      <button
        className="w-8 h-8 hover:bg-gray-100 rounded-full transition-colors duration-200 relative flex items-center justify-center"
        onClick={() => setOpenSideDrawer(true)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {QuestionMarkCircle(false, 24, isHovered ? '#606169' : '#9CA3AF')}
      </button>

      {openSideDrawer && (
        <SideDrawer
          isOpen={openSideDrawer}
          onClose={() => setOpenSideDrawer(false)}
          title="Support"
          listItems={listItems}
        />
      )}
    </>
  );
}
